import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// constants
import { TOOLTIP } from '../../lib/Constants';

// components
import TooltipView from '../../components/Tooltip';

// actions
import { toggleTooltip } from '../../reducers/Tooltip/actions';

const TooltipPropTypes = {
  children: PropTypes.node, // Can be plain text or additional markup for aesthetic reasons
  toggle: PropTypes.bool.isRequired, // State of the tooltip
  dispatchToogleTooltip: PropTypes.func.isRequired, // Method to make app aware of tooltip state
  locale: PropTypes.string.isRequired, // Current user locale "en_US"
};

const TooltipDefaultProps = {
  children: null,
};

class Tooltip extends Component {
  constructor(props) {
    super(props);

    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  componentDidMount() {
    window.addEventListener(
      'mousedown',
      // eslint-disable-next-line arrow-parens
      e => {
        this.closeWindow(e);
      },
      false,
    );
  }

  closeWindow(e) {
    const { toggle } = this.props;

    const isDescendant = document
      .getElementsByClassName(TOOLTIP)[0]
      .contains(e.target);
    // eslint-disable-next-line react/destructuring-assignment
    if (toggle && !isDescendant) this.props.dispatchToogleTooltip(!toggle);
  }

  toggleTooltip(e) {
    const { toggle } = this.props;

    const isDescendant = document
      .getElementsByClassName(TOOLTIP)[0]
      .contains(e.target);
    // eslint-disable-next-line react/destructuring-assignment
    if (!isDescendant) this.props.dispatchToogleTooltip(!toggle);

    const closeBtn = e.target.className;
    // eslint-disable-next-line react/destructuring-assignment
    if (closeBtn) this.props.dispatchToogleTooltip(!toggle);
  }

  render() {
    const { children, toggle, locale } = this.props;

    return (
      <TooltipView
        toggle={toggle}
        handleClick={this.toggleTooltip}
        locale={locale}
      >
        {children}
      </TooltipView>
    );
  }
}

Tooltip.propTypes = TooltipPropTypes;

Tooltip.defaultProps = TooltipDefaultProps;

const mapStateToProps = state => ({
  toggle: state.Tooltip.toggle,
  locale: state.App.locale,
});

const mapDispatchToProps = dispatch => ({
  // eslint-disable-next-line arrow-parens
  dispatchToogleTooltip: toggle => {
    dispatch(toggleTooltip(toggle));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Tooltip);
